module.exports = __webpack_public_path__ + "e8f14a11ce4721cf1e776796e9b4aa41.pdf";


//////////////////
// WEBPACK FOOTER
// ./app/assets/data/coloring/nl2.pdf
// module id = 932
// module chunks = 3